module.exports = __webpack_public_path__ + "img/syukyaku-kyoutu-logo001.384c20a9.png";